import React, { useEffect, useState } from 'react';
import './NotFound.css';

const NotFound = () => {
  
  return (
  <div className="not-found">
    <div>
        <h1 >Oops! Page not found</h1>
        <p>We are unable to find the page you requested</p>
    </div>
  </div>
  );
};

export default NotFound;
